var Filter = (function () {

    var $ = require('jquery');
    var Utility = require('./../lib/utilities');
    var Template = require('./../lib/template');
    //  Location Manager (https://github.com/KidkArolis/location-bar)
    var LocationBar = require('./../lib/location-bar');

    var self = {};

    self.$filter = $('[data-ajax-area]');
    self.locationBar = new LocationBar();

    /**
     * Use the self.locationBar module to update the URL
     * @param {type} name
     * @param {type} value
     */
    self.updateURL = function (name, value) {
        var currentURL = Utility.getURLParams();
        var prefix = '';
        var pathname = window.location.pathname;

        //  Strip paginator from filter.
        //  When you're on page 2 and use the filter you need a new search, not a filtered page 2
        var url = pathname.replace(/page\/[0-9]\//g, '');

        if (value === '') {
            //  remove from query string
            delete currentURL[name];
        } else {
            //  Override the changed property
            currentURL[name] = value;
        }

        //  Generate new URL
        var newURL = Utility.arrayToQueryString(currentURL);

        if (newURL) {
            prefix = '?';
        }

        self.locationBar.update(url + prefix + newURL, { trigger: true });
    };

    self.init = function () {

        //  Check if filter exists
        if (self.$filter.length > 0) {

            self.postType = self.$filter.data('post-type');

            var $resultHolder = self.$filter.find('[data-results-holder]');
            var $paginationHolder = self.$filter.find('[data-pagination-holder]');

            self.$select = self.$filter.find('[data-filter-select-holder] select');
            self.$radio = self.$filter.find('[data-filter-radio-holder] input');

            self.locationBar.start({
                pushState: true
            });

            //  Ajax the changed URL
            self.locationBar.onChange(function (path) {

                //  Show loader
                App.Globals.$body.addClass('page-transition');

                var prefix = '?';
                if (path.indexOf('?') > -1) {
                    prefix = '&';
                }

                //  Add timestamp to avoid caching issues on backbutton
                var date = prefix + 'date=' + new Date().getTime() + '&json';
                var url = '/' + path + date;

                //  DEBUG
                if (App.Globals.debug) {
                    console.log(url);
                }

                $.ajax({
                    url: url,
                    dataType: 'json'
                }).done(function (data) {

                    Template.render($resultHolder, rk_globals.theme_path + '/views/parts/' + self.postType + '/set.twig', data);
                    Template.render($paginationHolder, rk_globals.theme_path + '/views/parts/pagination.twig', data);

                    //  Hide loader
                    App.Globals.$body.removeClass('page-transition');
                    App.Globals.$scrollAnimators.animate({
                        scrollTop: self.$filter.offset().top - $('#header').height() - $('.filter-block').height()
                    });

                });
            });

            //  Handle dropdown filters (taxonomies)
            self.$select
                .on('change', function () {

                    var $this = $(this);
                    var fieldName = $this.closest('select').attr('name');
                    var fieldValue = $this.val();

                    //  Update URL
                    self.updateURL(fieldName, fieldValue);
                });

            //  Handle radio buttons
            self.$radio
                .on('change', function () {

                    var $this = $(this);
                    var fieldName = $this.attr('name');
                    var fieldValue = $this.val();

                    //  Update URL
                    self.updateURL(fieldName, fieldValue);
                });

            //  Handle paginator
            $paginationHolder
                .on('click', 'a', function (ev) {
                    ev.preventDefault();

                    var href = this.href;
                    var url = href.replace(/^.*\/\/[^\/]+/, '');

                    //  Update URL
                    self.locationBar.update(url, { trigger: true });
                });

        }

    };

    return self;

}());

module.exports = Filter;
